import { Box, Stack, StackProps } from '@mui/system'
import { FC, PropsWithChildren } from 'react'
import type { StartEndTimeBox } from './StartEndTimeBox'

type ActivityFieldBoxProps = StackProps & {
  label: string
  labelTestId?: string
  width?: string
  flex?: number
  direction?: 'row' | 'column'

  /**
   * Use this to visually combine 2 of these boxes togther by removing the border radius and padding between them
   * so that they look like they are one single box. For example see {@link StartEndTimeBox}
   */
  combinedWith?: 'left' | 'right' | 'above' | 'below'
}

export const ActivityFieldBox: FC<PropsWithChildren<ActivityFieldBoxProps>> = ({ label, labelTestId, combinedWith, children, ...stackProps }) => {
  const { sx = {}, ...restStackProps } = stackProps
  return (
    <Stack
      sx={{
        backgroundColor: 'var(--bg-surface)',
        gap: 'var(--spacing-2xs)',
        paddingTop: combinedWith === 'above' ? 'var(--spacing-2xs)' : 'var(--spacing-s)',
        paddingBottom: combinedWith === 'below' ? 'var(--spacing-2xs)' : 'var(--spacing-s)',
        paddingRight: combinedWith === 'right' ? 'var(--spacing-2xs)' : 'var(--spacing-s)',
        paddingLeft: combinedWith === 'left' ? 'var(--spacing-2xs)' : 'var(--spacing-s)',
        borderTopLeftRadius: combinedWith === 'above' || combinedWith === 'left' ? 0 : 'var(--border-radius-l)',
        borderTopRightRadius: combinedWith === 'above' || combinedWith === 'right' ? 0 : 'var(--border-radius-l)',
        borderBottomLeftRadius: combinedWith === 'below' || combinedWith === 'left' ? 0 : 'var(--border-radius-l)',
        borderBottomRightRadius: combinedWith === 'below' || combinedWith === 'right' ? 0 : 'var(--border-radius-l)',
        ...sx
      }}
      {...restStackProps}
    >
      <Box
        sx={{ fontSize: 'var(--size-xs)', color: 'var(--text-secondary)', lineHeight: 'var(--line-height-xs)', letterSpacing: '-0.5px' }}
        data-testid={labelTestId}
      >
        {label}
      </Box>
      {children}
    </Stack>
  )
}
